import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import userReducer from "./user/userReducer";
import omsReducer from "./oms/omsReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
};

const rootReducer = combineReducers({
  user: userReducer,
  oms: omsReducer,
});

export default persistReducer(persistConfig, rootReducer);
